module.exports = __webpack_public_path__ + "img/19.a82f4453.jpg";